export { default } from './personalized-carousel-loading-state';
